import React, { useState, useId } from 'react';
import { useLingui } from '@lingui/react';
import { splitStringByLine } from '@wkda/funnel-utils';
import { useGetConsumerCarlead, useHandoverProps } from '@wkda/funnel-components';
import { Button } from '../../shared';
import { getPriceStatus } from '../../../helpers';
import { scrollTo } from '../../../helpers/scrollTo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CollapsableFaqItem = ({
  question,
  answer
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const contentId = useId();
  const headerId = useId();
  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setIsCollapsed(previousState => !previousState);
    }
  };
  return /*#__PURE__*/_jsxs("article", {
    className: `accordion-item ${isCollapsed ? 'opened' : ''}`,
    children: [/*#__PURE__*/_jsx("button", {
      id: headerId,
      className: `accordion-title ${isCollapsed ? 'active' : ''}`,
      onClick: () => setIsCollapsed(previousState => !previousState),
      onKeyDown: handleKeyDown,
      dangerouslySetInnerHTML: {
        __html: question
      },
      "aria-expanded": isCollapsed,
      "aria-controls": contentId
    }), /*#__PURE__*/_jsx("div", {
      id: contentId,
      className: "accordion-content",
      role: "region",
      "aria-labelledby": headerId,
      "aria-hidden": !isCollapsed,
      children: /*#__PURE__*/_jsx("div", {
        className: "accordion-question-wrapper",
        dangerouslySetInnerHTML: {
          __html: answer
        }
      })
    })]
  });
};
export const CollapsedFaq = ({
  type = undefined,
  headline = true,
  cta = true,
  ctaScrollTarget = 'body'
}) => {
  const {
    i18n
  } = useLingui();
  const carLeadData = useGetConsumerCarlead();
  const priceStatus = getPriceStatus(carLeadData);
  const data = useHandoverProps();
  const riskFree = data.isRiskFree;
  const faqId = useId();
  const title = type === 'selfeva' ? i18n._('selfInspection.faq.title') : i18n._('booking.faq.title');
  const invalidQuestionTranslation = i18n._('booking.faq.invalid.question');
  const validQuestionTranslation = i18n._('booking.faq.valid.question');
  const invalidAnswerTranslation = i18n._('booking.faq.invalid.answer');
  const validAnswerTranslation = i18n._('booking.faq.valid.answer');
  const list = type === 'carlead' ? i18n._('carlead.faq.question') : type === 'selfeva' ? i18n._('selfInspection.faq.question') : priceStatus === 'reeva' ? invalidQuestionTranslation : validQuestionTranslation;
  const answers = type === 'carlead' ? i18n._('carlead.faq.answer') : type === 'selfeva' ? i18n._('selfInspection.faq.answer') : priceStatus === 'reeva' ? invalidAnswerTranslation : validAnswerTranslation;
  const formattedAnswers = splitStringByLine(answers).filter(Boolean);
  const ctaLabel = type === 'selfeva' ? i18n._('selfInspection.faq.cta') : i18n._('booking.faq.button.label');
  const content = {
    cta: {
      text: {
        full: ctaLabel
      },
      className: 'btn btn-secondary btn-lg btn-arrow btn-gradient btn-shadow',
      action: 'goTop',
      dataLabel: 'CTA - Accordion'
    }
  };
  return /*#__PURE__*/_jsxs("section", {
    className: `faq-accordion chevron-right ${riskFree ? 'risk-free' : 'balance-sheet'}`,
    "data-category": "FAQ",
    "aria-labelledby": headline ? faqId : undefined,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "accordion",
      role: "group",
      children: [headline && /*#__PURE__*/_jsx("h2", {
        id: faqId,
        className: "title",
        children: title
      }), splitStringByLine(list).filter(Boolean).map((item, index) => {
        return /*#__PURE__*/_jsx(CollapsableFaqItem, {
          question: item,
          answer: formattedAnswers[index],
          index: index
        }, index);
      })]
    }), cta && /*#__PURE__*/_jsx(Button, {
      data: content.cta,
      handleClick: () => scrollTo(ctaScrollTarget)
    })]
  });
};